export default class ShopifyClient {
  constructor(accessToken) {
    this.accessToken = accessToken;
  }

  async fetchProducts(productIds) {
    const query = `
      query {
        nodes(ids: ${JSON.stringify(productIds)}) {
          ... on Product {
            id
            handle
            title
            vendor
            productType
            featuredImage {
              width
              height
              url
            }
            images(first: 100) {
              edges {
                node {
                  width
                  height
                  url
                }
              }
            }
            availableForSale
            priceRange {
              minVariantPrice { amount }
              maxVariantPrice { amount }
            }
            compareAtPriceRange{
              minVariantPrice { amount }
              maxVariantPrice { amount }
            }
            totalInventory
            options(first: 3) {
              id
              name
              values
            }
            variants(first: 100) {
              nodes {
                id
                availableForSale
                price { amount }
                quantityAvailable
                image {
                  url
                }
                selectedOptions {
                  name
                  value
                }
              }
            }
            tags
            sales_type: metafield(namespace: "custom", key: "sales_type") {
              value
            }
            color: metafield(namespace: "custom", key: "color") {
              value
            }
            color_variations: metafield(namespace: "custom", key: "color_variations") {
              references(first: 100) {
                nodes {
                  ... on Product {
                    id
                    handle
                    color: metafield(namespace: "custom", key: "color") {
                      value
                    }
                  }
                }
              }
            }
            hover_image: metafield(namespace: "custom", key: "hover_image") {
              value
            }
          }
        }
      }
    `;

    return new Promise((resolve, reject) => {
      fetch('/api/2024-04/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'x-shopify-storefront-access-token': this.accessToken,
        },
        body: JSON.stringify({ query: query })
      }).then(response => {
        return response.json()
      }).then(response => {
        if (!response || response['data'] === undefined) {
          resolve([])
        }
        const products = Array.from(response.data.nodes).filter(node => node !== null)
        resolve(products)
      });
    });
  }


  async fetchProductByHandle(handle) {
    const query = `
      query {
        product(handle: "${handle}") {
          ... on Product {
            id
            handle
            title
            vendor
            productType
            featuredImage {
              width
              height
              url
            }
            images(first: 100) {
              edges {
                node {
                  width
                  height
                  url
                }
              }
            }
            availableForSale
            priceRange {
              minVariantPrice { amount }
              maxVariantPrice { amount }
            }
            compareAtPriceRange{
              minVariantPrice { amount }
              maxVariantPrice { amount }
            }
            totalInventory
            options(first: 3) {
              id
              name
              values
            }
            variants(first: 100) {
              nodes {
                id
                availableForSale
                price { amount }
                quantityAvailable
              }
            }
            tags
            sales_type: metafield(namespace: "custom", key: "sales_type") {
              value
            }
            color: metafield(namespace: "custom", key: "color") {
              value
            }
            color_variations: metafield(namespace: "custom", key: "color_variations") {
              references(first: 100) {
                nodes {
                  ... on Product {
                    id
                    handle
                    color: metafield(namespace: "custom", key: "color") {
                      value
                    }
                  }
                }
              }
            }
            hover_image: metafield(namespace: "custom", key: "hover_image") {
              value
            }
          }
        }
      }
    `;

    return new Promise((resolve, reject) => {
      fetch('/api/2024-04/graphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'x-shopify-storefront-access-token': this.accessToken,
        },
        body: JSON.stringify({ query: query })
      }).then(response => {
        return response.json()
      }).then(response => {
        if (!response || response['data'] === undefined) {
          resolve([])
        }
        resolve(response.data.product)
      });
    });
  }


}
